import React, { useCallback, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { AiVideoForm, AiVideoCard } from "@/components/AiVideos";
import { toast } from "sonner";

export default function AiVideos() {
  const { user } = useAuth();
  const [videos, setVideos] = useState([]);
  const load = useCallback(() => api.get("/ai-videos").then((r) => setVideos(r.data)).catch(() => {}), []);
  useEffect(() => { if (user?.is_super_admin) load(); }, [user, load]);
  const processing = videos.some((v) => v.status === "processing");
  useEffect(() => {
    if (!processing) return undefined;
    const t = setInterval(load, 6000);
    return () => clearInterval(t);
  }, [processing, load]);

  if (!user?.is_super_admin) return <Navigate to="/" replace />;

  const remove = async (v) => {
    if (!window.confirm(`Delete "${v.title}"?`)) return;
    try { await api.delete(`/ai-videos/${v.id}`); setVideos((p) => p.filter((x) => x.id !== v.id)); toast.success("Video deleted"); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  return (
    <div data-testid="ai-videos-page" className="space-y-8">
      <div>
        <div className="label-caps">Super Admin · fal.ai</div>
        <h2 className="font-display font-black text-3xl text-forest tracking-tight mt-1">AI promo videos</h2>
        <p className="text-sm text-forest/60 mt-2 max-w-2xl">Turn a project photo into a short moving promo clip for ads and social posts.</p>
      </div>
      <div className="grid grid-cols-1 xl:grid-cols-[minmax(0,460px)_1fr] gap-6 items-start">
        <AiVideoForm onCreated={(v) => setVideos((p) => [v, ...p])} />
        <div className="space-y-3 min-w-0">
          <div className="flex items-baseline justify-between">
            <h3 className="font-display font-bold text-xl text-forest">Gallery</h3>
            <span data-testid="ai-video-count" className="text-xs text-forest/50">{videos.length} {videos.length === 1 ? "video" : "videos"}</span>
          </div>
          {videos.length === 0 ? (
            <div data-testid="ai-video-empty" className="border border-dashed border-[#E6E4DD] rounded-sm p-10 text-center text-sm text-forest/50">No videos yet. Your first promo will appear here.</div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {videos.map((v) => <AiVideoCard key={v.id} v={v} onDelete={remove} />)}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
